import { makeGqlRequest } from './helpers'
import { getJobs, getUsers, getJobApplications } from './queries'
import { FetchJobsPayload, FetchUsersPayload, Job, FetchJobApplicationPayload } from './types'

export async function fetchUsers (payload: FetchUsersPayload, jwt: string) {
  const { users } = await makeGqlRequest(getUsers, payload, jwt)
  return users
}

export async function fetchJobs (payload: FetchJobsPayload, jwt: string): Promise<Job[]> {
  const { jobs } = await makeGqlRequest(getJobs, payload, jwt)
  return jobs.jobs
}

export async function fetchJobApplications (payload: FetchJobApplicationPayload, jwt: string) {
  const { jobApplications } = await makeGqlRequest(getJobApplications, payload, jwt)
  return jobApplications
}
